// extracted by mini-css-extract-plugin
export default {"wrapper":"onboard_wrapper__k5+Wz"};